export default __webpack_public_path__ + "static/media/instrucciones.5eff6e27.png";